import translations from './MarketingVideo.translations'
import type { MarketingVideoDescriptor } from './MarketingVideo.types'

// Cloudflare R2 public bucket, fronted by the BM CDN.
export const MARKETING_VIDEO_BASE_URL =
  'https://product-page-videos.statics.backmarket.com'

// Default (and currently only) gallery video. The descriptor shape is
// deliberately generic so per-country / per-product maps or extra formats are
// a trivial extension later — the component stays asset-agnostic.
export const DEFAULT_MARKETING_VIDEO: MarketingVideoDescriptor = {
  // WebM first (smaller on Chrome/Firefox/Android), H.264 MP4 fallback
  // (Safari/iOS). The browser plays the first <source> it supports.
  files: ['used-vs-verified.webm', 'used-vs-verified.mp4'],
  // Bundled with the app (public/img), not the R2 bucket — the poster shows
  // immediately even before the video assets have loaded.
  posterFile: '/img/product/gallery/generic-poster.jpg',
  title: translations.marketingVideoGenericTitle,
}

const MARKETING_CATEGORIES = {
  IPHONE: 'IPHONE',
  ANDROID: 'ANDROID',
  LAPTOP: 'LAPTOP',
  MACBOOK: 'MACBOOK',
  AIRPODS: 'AIRPODS',
} as const

export const MARKETING_VIDEOS: Record<
  keyof typeof MARKETING_CATEGORIES,
  MarketingVideoDescriptor
> = {
  [MARKETING_CATEGORIES.IPHONE]: {
    files: ['iphone.webm', 'iphone.mp4'],
    posterFile: '/img/product/gallery/iphone-poster.jpg',
    title: translations.marketingVideoIphoneTitle,
  },
  [MARKETING_CATEGORIES.ANDROID]: {
    files: ['android.webm', 'android.mp4'],
    posterFile: '/img/product/gallery/android-poster.jpg',
    title: translations.marketingVideoAndroidTitle,
  },
  [MARKETING_CATEGORIES.LAPTOP]: {
    files: ['laptop.webm', 'laptop.mp4'],
    posterFile: '/img/product/gallery/laptop-poster.jpg',
    title: translations.marketingVideoLaptopTitle,
  },
  [MARKETING_CATEGORIES.MACBOOK]: {
    files: ['macbook.webm', 'macbook.mp4'],
    posterFile: '/img/product/gallery/macbook-poster.jpg',
    title: translations.marketingVideoMacbookTitle,
  },
  [MARKETING_CATEGORIES.AIRPODS]: {
    files: ['airpods.webm', 'airpods.mp4'],
    posterFile: '/img/product/gallery/airpods-poster.jpg',
    title: translations.marketingVideoAirpodsTitle,
  },
}
